'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _badge = require('./badge');

var _badge2 = _interopRequireDefault(_badge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _badge2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/build/packages/components/badge/index.js
// module id = 2196
// module chunks = 0